export default "__VITE_ASSET__DBZvQ88$__"